import { useWizardState } from './WizardState';

export function CurrentStep() {
  const wizardState = useWizardState();

  return (
    <>
      {wizardState.currentStep.render({
        stepNum: wizardState.stepNum,
        setStep: wizardState.setStep,
        next: wizardState.next,
        prev: wizardState.prev,
      })}
    </>
  );
}
